import { Toggle } from '@bitcine/cinesend-theme/dist'

const IsLocalizable = ({ field, saveField }) => {
  const isLocalizable = field.is_localizable
  return (
    <Toggle
      checked={isLocalizable}
      label='Are values localizable?'
      disabled={field.schema.is_locked}
      onChange={() => {
        saveField({ is_localizable: !isLocalizable })
      }}
    />
  )
}

export default IsLocalizable
